import React from "react";

type TabsNavContainerProps = {
  children: React.ReactNode;
  variant?: "primary" | "secondary";
  className?: string;
};

const styles = {
  primary:
    "w-full sm:mx-auto border-b dark:border-gray-600 border-gray-300 overflow-x-auto overflow-y-hidden no-scrollbar",
  secondary: "w-full sm:mx-auto overflow-x-auto overflow-y-hidden no-scrollbar",
};

const TabsNavContainer: React.FC<TabsNavContainerProps> = ({
  children,
  variant = "primary", // Default variant
  className = "",
}) => {
  const variantClasses = styles[variant];

  return (
    <div id="navigation" className={`${variantClasses} ${className}`}>
      <div>
        <nav className="flex gap-2 items-stretch" aria-label="Tabs">
          {children}
        </nav>
      </div>
    </div>
  );
};

export default TabsNavContainer;
